import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Akte_Main } from './Akte/Akte.Main';
import { AdminMainTemplate } from './Admin/Pages/MainTemplate';
import { AdminIndex } from './Admin/Pages/ListPages/AdminIndex';
import { Geraet } from './Admin/Pages/ListPages/Geraet';
import { GeraetModell } from './Admin/Pages/ListPages/GeraetModell';
import { LeitstelleList } from './Admin/Pages/ListPages/Leitstelle';
import { LeistungList } from './Admin/Pages/ListPages/Leistung';
import { KooperationsPartnerList } from './Admin/Pages/ListPages/KooperationsPartner';
import { authGuard, isAuthGuard } from './Admin/AdminGuard';
import { ArtikelList } from './Admin/Pages/ListPages/ArtikelList';
import { GruendeList } from './Admin/Pages/ListPages/Gruende';
import { KassenList } from './Admin/Pages/ListPages/Kassen';
import { MainTemplate } from './Main/Pages/MainTemplate';
import { StatusView } from './Main/Pages/Status/StatusView';
import { LoginView } from './Main/Pages/Login/LoginView';
import { VersandStatus } from './Main/Pages/Versand/VersandStatus';
import {AuthorizeGuard} from './Directives/AuthorizationDirective';
import {Rights, StatusRights} from './Api/DcoApi/Client/RestClient';
import {FactoringStatusView} from './Main/Pages/Factoring/FactoringStatusView';
import {App} from './app';
import {IncommingCall} from './Main/Pages/Call/IncommingCall';
import {Abrechnung} from './Main/Pages/Abrechnung/Abrechnung';
import { Absetzung } from "./Main/Pages/Abrechnung/Absetzung";
import {Austausch} from './Main/Pages/Austausch/Austausch';
import {ReportAdminList} from './Admin/Reporting/report-admin-list/report-admin-list';
import {SubscriptionList} from './Admin/WebHook/Pages/subscription-list/subscription-list';

const routes: Routes = [
  {
    path: 'Akte/:VersicherungsNr/:VertragID',
    component: Akte_Main,
    canActivate: [isAuthGuard]
  }, {
    path: 'Akte/:VersicherungsNr',
    component: Akte_Main,
    canActivate: [isAuthGuard]
  }, {
    path: 'Akte',
    component: Akte_Main,
    canActivate: [isAuthGuard]
  },
  {
    path: 'Admin',
    component: AdminMainTemplate,
    children: [
      { path: '', component: AdminIndex },
      { path: 'Geraet', component: Geraet },
      { path: 'GeraetModell', component: GeraetModell },
      { path: 'Leitstellen', component: LeitstelleList },
      { path: 'Leistungen', component: LeistungList },
      { path: 'Partner', component: KooperationsPartnerList },
      { path: 'Artikel', component: ArtikelList },
      { path: 'Gruende', component: GruendeList },
      { path: 'Kassen', component: KassenList },
      { path: 'Report', component: ReportAdminList },
      { path: 'Subscription', component: SubscriptionList },
    ],
    canActivate: [authGuard]
  },
  {
    path: '',
    component: MainTemplate,
    children: [
      { path: 'Index', component: App },
      { path: '', component: StatusView, data: { Right: Rights.Status, OverrideRight: "HatWelcomeCallBerechtigung", SubRight: StatusRights.S_1Gesamt , AltUrl: '/Index' } },
      { path: 'Status', component: StatusView, data: { Right: Rights.Status, OverrideRight: "HatWelcomeCallBerechtigung", SubRight: StatusRights.S_1Gesamt, AltUrl: '/Index' } },
      { path: 'Status/:Status', component: StatusView, data: { Right: Rights.Status, OverrideRight: "HatWelcomeCallBerechtigung", AltUrl: '/Index' } },
      { path: 'Versand/:Status', component: VersandStatus },
      { path: 'Call/:number', component: IncommingCall },
      { path: 'Factoring', component: FactoringStatusView, data: { Right: Rights.FactoringView } },
      { path: 'Abrechnung', component: Abrechnung, data: { Right: Rights.Abbrechnung } },
      { path: 'Absetzung', component: Absetzung, data: { Right: Rights.Absetzung } },
      { path: 'Absetzung/:Partner', component: Absetzung, data: { Right: Rights.Absetzung } },
      { path: 'Absetzung/:Partner/:Lauf', component: Absetzung, data: { Right: Rights.Absetzung } },
      { path: 'Absetzung/Patient/:Customer', component: Absetzung, data: { Right: Rights.Absetzung } },
      { path: 'Austausch', component: Austausch, data: { Right: Rights.Status, OverrideRight: "HatWelcomeCallBerechtigung", SubRight: StatusRights.S100Austausch, AltUrl: '/Index' } },
    ],
    canActivate: [AuthorizeGuard],
    canActivateChild: [AuthorizeGuard]
  },
  {
    path: 'login',
    component: LoginView
  },
  {
    path: 'lgRet',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule, RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
